import { useTenantConfiguration } from '../use-tenant-configuration';
import { AiProductKey, useHasAiPermission } from '../../components/ai-permissions/ai-permissions-provider';

export function useAiRolePermissions() {
  const { aiAccessControlEnabled } = useTenantConfiguration();
  const hasCitizenAssistantPermission = useHasAiPermission('summa');
  const hasDialogSupportPermission = useHasAiPermission('dialogstoette');

  function isAiProductAllowed(productKey: AiProductKey): boolean {
    if (!aiAccessControlEnabled) {
      return true;
    }

    switch (productKey) {
      case 'summa':
        return hasCitizenAssistantPermission;
      case 'dialogstoette':
        return hasDialogSupportPermission;
      default:
        return false;
    }
  }

  return {
    isAiProductAllowed
  };
}
